import React from 'react'

const Manual_ver_info_del_cliente_en_pedidos_de_clau_anonimo = () => {
  return (
    <>
          <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-32">
      <h1 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-12">
        Ver info del cliente en pedidos de Clau Anónimo
      </h1>

      {/* Primer iframe */}
      <iframe
        src="https://scribehow.com/embed/Ver_info_del_Cliente_en_Pedidos_de_Clau_Anonimo__zSxZxfBQTBKIy9WO9Di0IQ?as=video"
        width="100%"
        height="800"
        allowFullScreen
        style={{
          aspectRatio: '16 / 12',
          border: 0,
          minHeight: '480px'
        }}
      ></iframe>

      {/* Espacio opcional entre los iframes */}
      <div style={{ height: '32px' }} />

      <iframe
        src="https://scribehow.com/embed/MENU__Subcategorias__7u7tPG1YR-edDJDBbNuzLg?as=scrollable"
        className="scribe-iframe"
        width="100%"
        height="4000"
        allowFullScreen
        style={{
          border: 0,
          overflow: 'hidden',
        }}
      ></iframe>
      </div>
    </>
  )
}

export default Manual_ver_info_del_cliente_en_pedidos_de_clau_anonimo